import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function CookieBanner() {
  const [shown, setShown] = useState(false);
  const [advanced, setAdvanced] = useState(false);
  const [prefs, setPrefs] = useState({ necessary: true, analytics: false, marketing: false });

  useEffect(() => {
    try {
      const saved = localStorage.getItem('fm_cookies');
      if (!saved) setShown(true);
    } catch { setShown(true); }
  }, []);

  function save(choice) {
    const final =
      choice === 'all' ? { necessary: true, analytics: true, marketing: true }
      : choice === 'reject' ? { necessary: true, analytics: false, marketing: false }
      : prefs;
    try { localStorage.setItem('fm_cookies', JSON.stringify({ ...final, ts: Date.now() })); } catch {}
    setShown(false);
  }

  if (!shown) return null;

  return (
    <div className="cookie-banner" role="dialog" aria-label="הסכמה לעוגיות">
      <div className="cookie-inner">
        <div className="cookie-body">
          <h3>אנחנו משתמשים בעוגיות (Cookies)</h3>
          <p>
            האתר משתמש בעוגיות כדי לשפר את חוויית הגלישה, לנתח שימוש ולשפר את התוכן.
            אפשר לאשר הכל, לדחות או להתאים אישית.
            למידע נוסף ראו <Link to="/privacy">מדיניות הפרטיות</Link>.
          </p>
          {advanced && (
            <div className="cookie-prefs">
              <label className="ck-always"><input type="checkbox" checked disabled readOnly /> חיוניות (תמיד פעיל)<small>נדרשות כדי שהאתר יעבוד. לא משמשות למעקב.</small></label>
              <label>
                <input
                  type="checkbox"
                  checked={prefs.analytics}
                  onChange={e => setPrefs(p => ({ ...p, analytics: e.target.checked }))}
                /> ניתוח שימוש (אנליטיקס)
              </label>
              <label>
                <input
                  type="checkbox"
                  checked={prefs.marketing}
                  onChange={e => setPrefs(p => ({ ...p, marketing: e.target.checked }))}
                /> שיווק ופרסום
              </label>
            </div>
          )}
        </div>
        <div className="cookie-actions">
          <button className="ck-btn ck-primary" onClick={() => save('all')}>אישור הכל</button>
          <button className="ck-btn ck-ghost" onClick={() => save('reject')}>דחיית הכל</button>
          {!advanced && (
            <button className="ck-btn ck-link" onClick={() => setAdvanced(true)}>התאמה אישית</button>
          )}
          {advanced && (
            <button className="ck-btn ck-ghost" onClick={() => save('custom')}>שמירת בחירה</button>
          )}
        </div>
      </div>
    </div>
  );
}
